import { convertToNumber, isValidNumber } from "../../utils/isValidNumber";
import {
  calcInteresCorrienteV2,
  calcularInteresCorrienteTed,
  calcularInteresCorrienteTem,
} from "../../utils/creditUser/calcInteresCorriente";

/**
 * Calcula el interés corriente según monto y días de vencimiento.
 * @param {number} amount - Monto solicitado.
 * @param {number} vencimientoEnDias - Plazo en días.
 * @param {object} options - Opciones { tea, tasaUsuraTmlv }.
 * @returns {number} Interés calculado.
 */
export function calculateInterest(amount, vencimientoEnDias, options = {}) {
  try {
    let { tea = 25, tasaUsuraTmlv = 25 } = options;

    tea = convertToNumber(tea);
    if (!isValidNumber(tea)) tea = 25;

    tasaUsuraTmlv = convertToNumber(tasaUsuraTmlv);

    if (tea > tasaUsuraTmlv) {
      tea = tasaUsuraTmlv;
    }

    return calcInteresCorrienteV2(amount, vencimientoEnDias, calcTed(tea));
  } catch {
    return 0;
  }
}

function calcTed(tea) {
  let interesCorrienteTem = calcularInteresCorrienteTem(tea);
  return calcularInteresCorrienteTed(interesCorrienteTem);
}
